export { default } from './AdCard'
